import { render, staticRenderFns } from "./EmployeeAttendanceFloatBtns.vue?vue&type=template&id=4c19aaa3&"
import script from "./EmployeeAttendanceFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EmployeeAttendanceFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports